/**
 * Formats a relative time label for a recently viewed product card.
 *
 * @param minutesAgo - How many minutes ago the product was viewed.
 * @param rtf - An `Intl.RelativeTimeFormat` instance pre-configured for the desired locale.
 * @returns A locale-aware relative time string (e.g. "2 hours ago", "hace 2 horas").
 */
export function formatViewedLabel(
  minutesAgo: number,
  rtf: Intl.RelativeTimeFormat,
): string {
  const hoursAgo = Math.round(minutesAgo / 60);
  const daysAgo = Math.round(minutesAgo / 1440);
  const weeksAgo = Math.round(minutesAgo / 10080);
  const monthsAgo = Math.round(minutesAgo / 43200);
  switch (true) {
    case minutesAgo < 60:
      return rtf.format(-minutesAgo, "minute");
    case minutesAgo < 1440:
      return rtf.format(-hoursAgo, "hour");
    case daysAgo === 1:
      return rtf.format(-1, "day");
    case daysAgo < 7:
      return rtf.format(-daysAgo, "day");
    case weeksAgo === 1:
      return rtf.format(-1, "week");
    case weeksAgo < 5:
      return rtf.format(-weeksAgo, "week");
    case monthsAgo === 1:
      return rtf.format(-1, "month");
    default:
      return rtf.format(-monthsAgo, "month");
  }
}
